export const Employee = (json: IEmployee): IEmployeeModel => {
	const fromJSON = () => {
		const { is_active, first_name, last_name, phone_number, created_at, role, ...rest } = json
		return {
			isActive: is_active,
			firstName: first_name,
			lastName: last_name,
			phoneNumber: phone_number,
			createdAt: created_at ? new Date(created_at) : null,
			role: mapRoleToSelectOption(role),
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const employeeToJSON = (obj: Partial<IEmployeeModel>): Partial<IEmployee> => {
	const { isActive, firstName, lastName, phoneNumber, role, ...rest } = obj
	return {
		is_active: isActive,
		first_name: firstName,
		last_name: lastName,
		phone_number: phoneNumber,
		role: role?.value,
		...rest,
	}
}
